/**
 * 接口统一管理文件
 * Created by kahn on 2020/09/09.
 */
export default {
    frontendLogin: 'user/login',//账号登录接口
    frontendRegister: 'user/register', // 注册
    frontendRegisterSms: 'user/register/sms', // 注册短信
    frontendPasswordSms: 'user/password/sms', // 重置密码短信
    frontendResetPassword: 'user/reset/password', // 重置密码
    frontendResetPasswordNext: 'user/register/next_step', // 注册/忘记密码下一步
    frontendUserExam: 'user/exam', // 我的考试
    frontendProjectAll: 'project/all', // 招考项目
    frontendProjectNotice: 'project/notice', // 招聘公告
    frontendProjectProcessList: 'project/process', // 项目流程
    frontendProjectUnitList: 'project/unit', // 岗位列表

    frontendProjectQuestionList: 'user/question/list', // 项目问答列表
    frontendQuestionAdd: 'user/question/add', // 新增项目问题
    frontendQuestionPraise: 'user/question/praise', // 问题点赞
    frontendQuestionCancelPraise: 'user/question/cancelPraise', // 问题取消点赞

    frontendUserUpadteMobie: 'user/update/mobile', // 保存资料修改手机
    frontendUserMaterialInfo: 'user/material/info', // 获取用户所有资料
    frontendUserMaterialSave: 'user/material/save', // 报考资料提交
    frontendUserGetUnit: 'user/get/unit', // 岗位信息搜索
    frontendUserReferApply: 'user/refer/apply', // 提交报名
    frontendUserGetAttr: 'user/get/attr', // 从材料库获取
    frontendUserToolAttr: 'user/tool/attr', // 获取报名所需附件
    frontendUserToolFiled: 'user/tool/filed', // 获取额外字段

    frontendUserFileNotInfo: 'user/update/material/info', // 不通过返回修改报考信息
    frontendUserFileSubmit: 'user/apply/attr/supplementMaterial', // 直接提交错误材料

    frontendUserExamEntrance: 'user/exam/entrance', // 准考证入口

    frontendUserScoresWriten: 'user/scores/written', // 笔试成绩入口
    frontendUserScoresInterview: 'user/scores/interview', // 面试成绩入口

    frontendUserMessageList: 'user/message/list', // 用户消息列表
    frontendUserMessageRead: 'user/message/read', // 用户消息读取
    
    frontendProjectCodeToId: 'project/codeToid', // 项目code转换id
    userProjectDownloadInfo: 'user/project/downloadInfo',//项目下载文件说明详情

    userScoresGetExamineResult: 'user/scores/getExamineResult',//查看用户成绩
    userDownloadUserInfo: 'user/download/userInfo',//用户报名表pdf下载
}


// WEBPACK FOOTER //
// ./src/js/interface/index.js